// extracted by mini-css-extract-plugin
export default {"columnHeader":"ColumnHeaderName_columnHeader__sLKKt"};